import { TranslationsSchema } from './i18n';

export const wrapTranslationsSchema = <const T extends TranslationsSchema>(schema: T) => {
	// In the future we may add more adjustments here.
	// We don't call createTranslationsSchema() here as it will
	// convert fields to array that is harder to process!
	// TODO: think about universal approach for pure translation documents and mixed documents.
	return schema;
};
